// Generated from the production Valhalla 3.7 bicycle engine on 2026-08-08.
// Coordinates use [longitude, latitude]. Douglas-Peucker simplification at
// roughly 20 metres preserves the road geometry while keeping the landing page lean.
export type DemoStage = {
  id: string;
  number: number;
  title: string;
  from: string;
  to: string;
  distanceKm: number;
  durationHours: number;
  state: 'complete' | 'live';
  coordinates: Array<[number, number]>;
};

export const demoStages: DemoStage[] = [
  {
    id: 'augsburg-landsberg',
    number: 1,
    title: 'Along the Lech',
    from: 'Augsburg',
    to: 'Landsberg am Lech',
    distanceKm: 40,
    durationHours: 2.4,
    state: 'complete',
    coordinates: [
      [10.898728, 48.36685],
      [10.899531, 48.364866],
      [10.90072, 48.364894],
      [10.900931, 48.364471],
      [10.901879, 48.364248],
      [10.902877, 48.362117],
      [10.903039, 48.360147],
      [10.902198, 48.359695],
      [10.902869, 48.358785],
      [10.902308, 48.357915],
      [10.902072, 48.353109],
      [10.907153, 48.338567],
      [10.908848, 48.318763],
      [10.909418, 48.316654],
      [10.907325, 48.311851],
      [10.904515, 48.307324],
      [10.900369, 48.29833],
      [10.8812, 48.254128],
      [10.867457, 48.227238],
      [10.867628, 48.226169],
      [10.868707, 48.224402],
      [10.867704, 48.221739],
      [10.867083, 48.221598],
      [10.865173, 48.222102],
      [10.86454, 48.221077],
      [10.857054, 48.206426],
      [10.854781, 48.201209],
      [10.855858, 48.199554],
      [10.855678, 48.198841],
      [10.853295, 48.197653],
      [10.851665, 48.195527],
      [10.842262, 48.177347],
      [10.841239, 48.1745],
      [10.842669, 48.173896],
      [10.838583, 48.165672],
      [10.838943, 48.165419],
      [10.837659, 48.162969],
      [10.839009, 48.16267],
      [10.838371, 48.161331],
      [10.837775, 48.160838],
      [10.837921, 48.160491],
      [10.836482, 48.157572],
      [10.832037, 48.157954],
      [10.831664, 48.15268],
      [10.83211, 48.146338],
      [10.830969, 48.144438],
      [10.832684, 48.144214],
      [10.833422, 48.134946],
      [10.835521, 48.129245],
      [10.847966, 48.116375],
      [10.850483, 48.110972],
      [10.8534, 48.102636],
      [10.852834, 48.10242],
      [10.854624, 48.097845],
      [10.853474, 48.097517],
      [10.854112, 48.096883],
      [10.855283, 48.091829],
      [10.857581, 48.086848],
      [10.856966, 48.08657],
      [10.857304, 48.085008],
      [10.857827, 48.083895],
      [10.859368, 48.084283],
      [10.862414, 48.075062],
      [10.861542, 48.074436],
      [10.861749, 48.074069],
      [10.857528, 48.073163],
      [10.859964, 48.067573],
      [10.86228, 48.05955],
      [10.86786, 48.058037],
      [10.868353, 48.056838],
      [10.870081, 48.057183],
      [10.872934, 48.056888],
      [10.875188, 48.055686],
      [10.877568, 48.053534],
      [10.876481, 48.0513],
      [10.877457, 48.051206],
      [10.877753, 48.050853],
      [10.876663, 48.049224],
      [10.87647, 48.048282],
      [10.876984, 48.048399],
      [10.877704, 48.049295],
    ],
  },
  {
    id: 'landsberg-fuessen',
    number: 2,
    title: 'Lakes toward Füssen',
    from: 'Landsberg am Lech',
    to: 'Füssen',
    distanceKm: 66.8,
    durationHours: 4,
    state: 'complete',
    coordinates: [
      [10.877704, 48.049295],
      [10.877726, 48.049021],
      [10.87596, 48.047753],
      [10.871873, 48.04647],
      [10.870343, 48.044683],
      [10.867205, 48.042836],
      [10.86777, 48.039772],
      [10.864277, 48.03937],
      [10.865528, 48.034423],
      [10.862703, 48.028881],
      [10.862227, 48.026682],
      [10.862156, 48.025891],
      [10.863106, 48.024981],
      [10.862629, 48.024176],
      [10.862641, 48.022535],
      [10.861017, 48.018547],
      [10.862266, 48.017934],
      [10.862483, 48.017325],
      [10.860528, 48.015325],
      [10.859782, 48.010982],
      [10.860254, 48.00951],
      [10.858994, 48.008127],
      [10.854129, 47.983199],
      [10.855461, 47.982479],
      [10.8558, 47.981454],
      [10.857402, 47.98111],
      [10.857162, 47.980861],
      [10.853733, 47.981196],
      [10.853178, 47.978318],
      [10.853655, 47.976686],
      [10.859299, 47.966691],
      [10.862735, 47.959579],
      [10.86251, 47.95916],
      [10.861934, 47.959066],
      [10.861949, 47.957314],
      [10.862014, 47.9569],
      [10.862475, 47.956988],
      [10.862487, 47.956118],
      [10.863351, 47.954582],
      [10.865084, 47.952426],
      [10.865916, 47.952093],
      [10.86914, 47.95217],
      [10.869612, 47.951349],
      [10.871202, 47.95013],
      [10.871185, 47.949539],
      [10.870601, 47.948952],
      [10.866834, 47.94782],
      [10.866939, 47.9465],
      [10.865953, 47.945673],
      [10.864294, 47.940182],
      [10.864617, 47.938672],
      [10.866738, 47.93543],
      [10.868256, 47.931795],
      [10.868708, 47.931703],
      [10.864057, 47.930042],
      [10.860287, 47.928274],
      [10.859608, 47.923506],
      [10.858848, 47.921739],
      [10.856318, 47.919029],
      [10.852515, 47.916173],
      [10.852471, 47.915797],
      [10.851901, 47.915795],
      [10.84989, 47.914362],
      [10.849351, 47.911291],
      [10.847916, 47.90972],
      [10.84712, 47.908184],
      [10.844952, 47.905412],
      [10.838942, 47.899165],
      [10.837752, 47.896225],
      [10.835556, 47.892488],
      [10.834623, 47.888842],
      [10.834339, 47.888488],
      [10.832412, 47.888572],
      [10.831766, 47.886037],
      [10.832369, 47.877489],
      [10.834345, 47.874242],
      [10.834223, 47.872508],
      [10.833167, 47.870863],
      [10.827405, 47.867554],
      [10.826407, 47.866397],
      [10.826389, 47.864864],
      [10.822917, 47.860937],
      [10.82312, 47.859946],
      [10.825747, 47.857253],
      [10.827319, 47.854616],
      [10.82715, 47.854119],
      [10.826013, 47.853261],
      [10.82495, 47.848922],
      [10.825426, 47.846681],
      [10.826681, 47.844683],
      [10.830285, 47.843053],
      [10.830623, 47.837401],
      [10.831869, 47.835635],
      [10.830816, 47.834333],
      [10.831181, 47.83356],
      [10.83282, 47.832148],
      [10.833701, 47.829833],
      [10.835176, 47.828459],
      [10.836083, 47.826574],
      [10.834106, 47.825485],
      [10.834516, 47.824601],
      [10.834279, 47.823868],
      [10.832423, 47.821557],
      [10.829543, 47.820449],
      [10.828891, 47.819947],
      [10.826447, 47.816322],
      [10.823295, 47.813199],
      [10.821098, 47.810468],
      [10.820221, 47.806603],
      [10.81996, 47.806231],
      [10.819015, 47.80605],
      [10.81887, 47.80439],
      [10.817803, 47.802379],
      [10.816287, 47.796947],
      [10.817902, 47.791702],
      [10.817777, 47.79052],
      [10.815917, 47.785944],
      [10.816973, 47.783092],
      [10.815973, 47.780354],
      [10.816477, 47.777168],
      [10.813885, 47.776803],
      [10.813059, 47.776102],
      [10.813789, 47.775437],
      [10.803945, 47.769743],
      [10.801562, 47.767707],
      [10.799188, 47.76458],
      [10.795475, 47.762114],
      [10.794334, 47.759362],
      [10.7948, 47.756103],
      [10.793165, 47.752466],
      [10.791662, 47.750392],
      [10.790888, 47.749686],
      [10.789038, 47.748819],
      [10.788448, 47.746684],
      [10.785745, 47.744547],
      [10.781544, 47.74289],
      [10.780301, 47.742101],
      [10.778107, 47.738925],
      [10.777954, 47.737083],
      [10.780328, 47.734132],
      [10.782666, 47.732199],
      [10.78221, 47.729817],
      [10.782335, 47.727637],
      [10.785269, 47.725706],
      [10.788173, 47.722188],
      [10.789179, 47.717488],
      [10.788721, 47.713855],
      [10.789099, 47.711905],
      [10.791783, 47.709977],
      [10.792838, 47.709601],
      [10.794796, 47.702682],
      [10.792065, 47.702008],
      [10.791633, 47.700363],
      [10.792454, 47.697664],
      [10.791052, 47.697121],
      [10.786957, 47.696569],
      [10.78199, 47.694515],
      [10.774092, 47.691834],
      [10.773791, 47.691268],
      [10.77193, 47.690091],
      [10.758581, 47.684271],
      [10.75188, 47.678747],
      [10.74566, 47.677618],
      [10.740588, 47.675701],
      [10.739085, 47.674431],
      [10.737067, 47.673599],
      [10.733709, 47.673715],
      [10.729501, 47.673371],
      [10.727146, 47.672945],
      [10.726166, 47.672488],
      [10.725231, 47.671476],
      [10.725569, 47.669619],
      [10.722407, 47.666396],
      [10.72267, 47.663619],
      [10.720791, 47.660631],
      [10.719619, 47.659704],
      [10.719092, 47.656978],
      [10.718237, 47.656038],
      [10.718859, 47.654775],
      [10.718731, 47.653926],
      [10.718025, 47.653482],
      [10.717992, 47.652665],
      [10.72134, 47.650861],
      [10.727172, 47.648515],
      [10.72912, 47.647148],
      [10.729266, 47.645779],
      [10.729639, 47.645752],
      [10.729339, 47.641152],
      [10.729643, 47.640215],
      [10.733723, 47.636391],
      [10.735378, 47.635836],
      [10.73577, 47.634562],
      [10.737902, 47.636432],
      [10.740974, 47.636552],
      [10.741605, 47.635181],
      [10.742022, 47.63243],
      [10.741957, 47.627461],
      [10.741144, 47.625261],
      [10.73898, 47.622196],
      [10.734548, 47.616388],
      [10.729401, 47.610936],
      [10.728014, 47.610089],
      [10.724263, 47.609102],
      [10.721982, 47.608936],
      [10.719219, 47.609704],
      [10.720489, 47.606183],
      [10.719889, 47.602499],
      [10.718306, 47.597819],
      [10.712601, 47.587302],
      [10.711064, 47.585885],
      [10.709036, 47.585497],
      [10.708517, 47.585861],
      [10.708095, 47.585756],
      [10.707779, 47.585967],
      [10.708247, 47.586747],
      [10.706595, 47.587459],
      [10.707371, 47.583639],
      [10.70726, 47.581847],
      [10.706694, 47.580803],
      [10.706242, 47.580669],
      [10.706269, 47.57992],
      [10.703257, 47.574925],
      [10.704341, 47.57473],
      [10.703249, 47.571835],
      [10.702085, 47.571907],
      [10.701876, 47.571361],
    ],
  },
  {
    id: 'fuessen-imst',
    number: 3,
    title: 'Across the Fern Pass',
    from: 'Füssen',
    to: 'Imst',
    distanceKm: 64.9,
    durationHours: 4.1,
    state: 'complete',
    coordinates: [
      [10.701876, 47.571361],
      [10.701039, 47.569645],
      [10.699476, 47.56977],
      [10.698297, 47.569036],
      [10.697202, 47.567807],
      [10.699248, 47.567612],
      [10.700138, 47.566823],
      [10.700435, 47.565321],
      [10.696457, 47.563068],
      [10.695508, 47.563055],
      [10.69506, 47.562775],
      [10.695707, 47.561108],
      [10.696477, 47.560577],
      [10.694659, 47.558385],
      [10.691934, 47.557403],
      [10.690198, 47.557494],
      [10.686244, 47.555865],
      [10.684136, 47.55558],
      [10.682936, 47.555149],
      [10.680889, 47.553777],
      [10.673636, 47.551606],
      [10.663879, 47.549832],
      [10.661583, 47.548481],
      [10.66186, 47.547875],
      [10.66366, 47.546867],
      [10.66302, 47.546098],
      [10.663608, 47.545378],
      [10.666914, 47.544759],
      [10.670151, 47.544842],
      [10.674876, 47.543814],
      [10.675653, 47.543473],
      [10.677396, 47.541624],
      [10.679422, 47.540606],
      [10.684959, 47.541184],
      [10.686453, 47.540913],
      [10.689095, 47.539351],
      [10.690044, 47.537744],
      [10.693815, 47.53496],
      [10.695911, 47.534116],
      [10.700308, 47.529849],
      [10.702846, 47.528687],
      [10.703345, 47.52644],
      [10.704223, 47.526202],
      [10.708452, 47.526613],
      [10.709376, 47.526446],
      [10.710698, 47.525201],
      [10.710339, 47.523661],
      [10.711506, 47.522678],
      [10.712699, 47.522324],
      [10.71395, 47.521109],
      [10.713498, 47.519617],
      [10.713783, 47.517189],
      [10.71431, 47.516237],
      [10.715779, 47.515479],
      [10.717369, 47.513776],
      [10.718049, 47.512568],
      [10.717882, 47.511248],
      [10.719908, 47.509345],
      [10.720091, 47.508723],
      [10.719461, 47.507701],
      [10.72037, 47.504849],
      [10.720301, 47.500727],
      [10.719489, 47.495468],
      [10.718039, 47.493551],
      [10.71752, 47.489746],
      [10.719228, 47.488192],
      [10.719637, 47.48663],
      [10.720797, 47.485421],
      [10.721178, 47.48421],
      [10.727775, 47.480421],
      [10.731228, 47.479325],
      [10.729756, 47.478413],
      [10.728595, 47.477033],
      [10.728203, 47.476016],
      [10.728553, 47.47498],
      [10.728279, 47.474188],
      [10.726304, 47.472992],
      [10.725648, 47.472258],
      [10.725344, 47.468076],
      [10.718361, 47.462549],
      [10.717603, 47.460581],
      [10.717884, 47.459744],
      [10.718765, 47.459346],
      [10.721507, 47.459237],
      [10.724222, 47.456281],
      [10.730962, 47.453949],
      [10.732087, 47.45295],
      [10.733093, 47.450703],
      [10.739302, 47.448754],
      [10.742025, 47.448435],
      [10.745731, 47.446945],
      [10.748103, 47.445228],
      [10.748663, 47.444187],
      [10.75004, 47.444123],
      [10.760461, 47.437884],
      [10.762031, 47.436707],
      [10.763221, 47.435031],
      [10.765909, 47.433361],
      [10.766619, 47.433276],
      [10.766696, 47.432487],
      [10.769861, 47.429969],
      [10.774705, 47.428155],
      [10.776992, 47.428126],
      [10.777678, 47.42645],
      [10.779111, 47.424734],
      [10.780851, 47.423521],
      [10.785725, 47.421695],
      [10.788256, 47.420176],
      [10.790826, 47.420162],
      [10.793363, 47.418384],
      [10.797623, 47.417102],
      [10.802475, 47.416969],
      [10.808162, 47.417918],
      [10.815166, 47.417619],
      [10.818694, 47.418372],
      [10.825778, 47.418165],
      [10.833104, 47.417505],
      [10.842082, 47.417552],
      [10.844342, 47.416925],
      [10.84659, 47.415744],
      [10.851467, 47.414671],
      [10.853923, 47.413811],
      [10.854698, 47.413986],
      [10.85614, 47.413061],
      [10.861088, 47.411437],
      [10.861923, 47.410926],
      [10.861785, 47.410188],
      [10.863099, 47.408673],
      [10.866609, 47.406543],
      [10.867173, 47.406499],
      [10.867972, 47.407214],
      [10.872329, 47.405438],
      [10.876776, 47.405106],
      [10.880702, 47.402006],
      [10.883788, 47.400912],
      [10.887766, 47.400817],
      [10.890643, 47.400163],
      [10.891966, 47.399525],
      [10.894418, 47.399437],
      [10.895786, 47.398547],
      [10.896515, 47.397301],
      [10.896309, 47.396489],
      [10.897148, 47.395175],
      [10.896881, 47.39459],
      [10.897278, 47.393017],
      [10.898146, 47.392474],
      [10.897339, 47.385802],
      [10.895945, 47.384969],
      [10.893182, 47.384688],
      [10.891605, 47.383236],
      [10.891142, 47.382363],
      [10.891552, 47.382008],
      [10.891489, 47.38104],
      [10.889393, 47.379544],
      [10.888902, 47.378473],
      [10.889265, 47.374482],
      [10.887255, 47.372043],
      [10.885483, 47.370965],
      [10.883232, 47.370181],
      [10.881657, 47.367899],
      [10.879548, 47.366303],
      [10.874926, 47.364951],
      [10.871209, 47.366668],
      [10.871449, 47.367181],
      [10.87189, 47.366894],
      [10.871422, 47.365094],
      [10.868462, 47.363097],
      [10.866654, 47.362774],
      [10.86296, 47.361487],
      [10.861229, 47.360568],
      [10.859036, 47.36077],
      [10.857262, 47.360602],
      [10.854516, 47.359523],
      [10.854283, 47.359242],
      [10.85522, 47.358252],
      [10.854831, 47.357391],
      [10.855179, 47.356586],
      [10.854782, 47.35616],
      [10.853013, 47.356159],
      [10.849167, 47.358244],
      [10.847362, 47.358471],
      [10.845555, 47.359572],
      [10.844566, 47.361129],
      [10.842668, 47.361446],
      [10.839557, 47.363412],
      [10.837784, 47.363915],
      [10.836589, 47.364137],
      [10.835247, 47.363995],
      [10.83118, 47.362609],
      [10.829216, 47.363092],
      [10.824443, 47.362938],
      [10.822887, 47.36315],
      [10.822338, 47.361426],
      [10.822501, 47.360134],
      [10.821588, 47.359331],
      [10.82409, 47.357807],
      [10.825673, 47.355876],
      [10.828066, 47.355257],
      [10.829551, 47.353688],
      [10.825214, 47.351144],
      [10.823714, 47.348155],
      [10.818908, 47.345669],
      [10.818701, 47.343661],
      [10.819674, 47.342851],
      [10.820047, 47.341735],
      [10.817567, 47.339285],
      [10.818908, 47.336383],
      [10.818174, 47.329613],
      [10.819351, 47.327744],
      [10.822675, 47.325262],
      [10.824246, 47.32218],
      [10.824807, 47.322049],
      [10.826049, 47.322365],
      [10.828016, 47.321379],
      [10.833965, 47.31601],
      [10.838705, 47.314175],
      [10.839315, 47.313612],
      [10.839987, 47.31213],
      [10.839676, 47.309184],
      [10.840144, 47.307857],
      [10.838712, 47.306973],
      [10.838496, 47.305642],
      [10.837119, 47.304061],
      [10.837033, 47.303496],
      [10.835792, 47.302895],
      [10.834897, 47.301212],
      [10.835022, 47.300033],
      [10.834524, 47.299297],
      [10.833997, 47.298645],
      [10.832181, 47.297861],
      [10.830478, 47.295831],
      [10.829169, 47.293482],
      [10.82561, 47.291686],
      [10.824103, 47.290095],
      [10.813837, 47.284522],
      [10.814524, 47.283446],
      [10.813958, 47.283103],
      [10.813953, 47.282547],
      [10.812247, 47.281721],
      [10.812407, 47.28156],
      [10.796919, 47.274003],
      [10.781563, 47.267539],
      [10.780258, 47.266427],
      [10.779713, 47.266843],
      [10.777622, 47.2653],
      [10.777097, 47.262937],
      [10.773988, 47.261425],
      [10.766496, 47.262407],
      [10.765504, 47.261832],
      [10.767153, 47.258873],
      [10.76683, 47.258357],
      [10.763161, 47.257042],
      [10.76201, 47.257217],
      [10.757914, 47.256111],
      [10.75588, 47.2546],
      [10.754983, 47.254558],
      [10.753681, 47.253297],
      [10.75289, 47.253219],
      [10.749922, 47.250909],
      [10.746374, 47.249053],
      [10.745382, 47.248171],
      [10.745549, 47.246618],
      [10.744593, 47.246183],
      [10.74318, 47.246523],
      [10.741417, 47.246128],
      [10.740468, 47.245367],
      [10.739424, 47.245244],
      [10.739607, 47.244972],
    ],
  },
  {
    id: 'imst-reschen',
    number: 4,
    title: 'Climb to Reschen Pass',
    from: 'Imst',
    to: 'Reschen Pass',
    distanceKm: 70.8,
    durationHours: 4.7,
    state: 'live',
    coordinates: [
      [10.739607, 47.244972],
      [10.7398, 47.244678],
      [10.740484, 47.244996],
      [10.74153, 47.244329],
      [10.74221, 47.24427],
      [10.741232, 47.243344],
      [10.741952, 47.240662],
      [10.744919, 47.239526],
      [10.744601, 47.238806],
      [10.749266, 47.235739],
      [10.750751, 47.233925],
      [10.75075, 47.229741],
      [10.749549, 47.22804],
      [10.749609, 47.224597],
      [10.750393, 47.221193],
      [10.751523, 47.219499],
      [10.753161, 47.218363],
      [10.752854, 47.218023],
      [10.749067, 47.216793],
      [10.738027, 47.216597],
      [10.725572, 47.21686],
      [10.719597, 47.216274],
      [10.717681, 47.216615],
      [10.700448, 47.214504],
      [10.70045, 47.213307],
      [10.699173, 47.213267],
      [10.695278, 47.212413],
      [10.69386, 47.212767],
      [10.684536, 47.208817],
      [10.677307, 47.20694],
      [10.676278, 47.204979],
      [10.675151, 47.204145],
      [10.67563, 47.203976],
      [10.673719, 47.202544],
      [10.672453, 47.202068],
      [10.671843, 47.200999],
      [10.668482, 47.200886],
      [10.666144, 47.200369],
      [10.663891, 47.199506],
      [10.661322, 47.198076],
      [10.656791, 47.197244],
      [10.655496, 47.196327],
      [10.654609, 47.19607],
      [10.652338, 47.196217],
      [10.646322, 47.193429],
      [10.64582, 47.193593],
      [10.645171, 47.193307],
      [10.6453, 47.193753],
      [10.64397, 47.193102],
      [10.643287, 47.191625],
      [10.642409, 47.190789],
      [10.640047, 47.189821],
      [10.640141, 47.187816],
      [10.637685, 47.186432],
      [10.636586, 47.186151],
      [10.633016, 47.186154],
      [10.630198, 47.185045],
      [10.618993, 47.182207],
      [10.616655, 47.180318],
      [10.614565, 47.177516],
      [10.612431, 47.176161],
      [10.61146, 47.175772],
      [10.606244, 47.174951],
      [10.601183, 47.17231],
      [10.594986, 47.170393],
      [10.591821, 47.16875],
      [10.591372, 47.168412],
      [10.592148, 47.167904],
      [10.59224, 47.166848],
      [10.590681, 47.165386],
      [10.592047, 47.165041],
      [10.590181, 47.162545],
      [10.592304, 47.160747],
      [10.589343, 47.157489],
      [10.587205, 47.156397],
      [10.588788, 47.155299],
      [10.586406, 47.153613],
      [10.58532, 47.15156],
      [10.584319, 47.151387],
      [10.583705, 47.15175],
      [10.583259, 47.151493],
      [10.584305, 47.150574],
      [10.584161, 47.150068],
      [10.579941, 47.14821],
      [10.57674, 47.146429],
      [10.574568, 47.145784],
      [10.572038, 47.142027],
      [10.569973, 47.140061],
      [10.567296, 47.138618],
      [10.567214, 47.136088],
      [10.569251, 47.133296],
      [10.574857, 47.129979],
      [10.576579, 47.128324],
      [10.578498, 47.128175],
      [10.581304, 47.126887],
      [10.584315, 47.126497],
      [10.587808, 47.125255],
      [10.597846, 47.123303],
      [10.607651, 47.117554],
      [10.615544, 47.117367],
      [10.619382, 47.115179],
      [10.625133, 47.114313],
      [10.630057, 47.114536],
      [10.633671, 47.114094],
      [10.635794, 47.114892],
      [10.63712, 47.115053],
      [10.642513, 47.113991],
      [10.643752, 47.114205],
      [10.646666, 47.113842],
      [10.652468, 47.1141],
      [10.654954, 47.113276],
      [10.658388, 47.110361],
      [10.660847, 47.106463],
      [10.662228, 47.105319],
      [10.664291, 47.102315],
      [10.66517, 47.097713],
      [10.666399, 47.095757],
      [10.667146, 47.093477],
      [10.667078, 47.092603],
      [10.665581, 47.089529],
      [10.664549, 47.085333],
      [10.661682, 47.082284],
      [10.660852, 47.080222],
      [10.661475, 47.077247],
      [10.662003, 47.077158],
      [10.664369, 47.075055],
      [10.666678, 47.071564],
      [10.666274, 47.071228],
      [10.663886, 47.070738],
      [10.663649, 47.069016],
      [10.661143, 47.066781],
      [10.660919, 47.065697],
      [10.65925, 47.063662],
      [10.658699, 47.061302],
      [10.65722, 47.058951],
      [10.657508, 47.058752],
      [10.657235, 47.058139],
      [10.655329, 47.056088],
      [10.655305, 47.055518],
      [10.654687, 47.055498],
      [10.653445, 47.054841],
      [10.651985, 47.052713],
      [10.647053, 47.049341],
      [10.64511, 47.048393],
      [10.642622, 47.047626],
      [10.640717, 47.045392],
      [10.640094, 47.045469],
      [10.63882, 47.044397],
      [10.631851, 47.040875],
      [10.630878, 47.040038],
      [10.629963, 47.038363],
      [10.629812, 47.036607],
      [10.630603, 47.036527],
      [10.630737, 47.035497],
      [10.631954, 47.03478],
      [10.630064, 47.031477],
      [10.628341, 47.03093],
      [10.626869, 47.029831],
      [10.626378, 47.027751],
      [10.621696, 47.02546],
      [10.618073, 47.023071],
      [10.609789, 47.020715],
      [10.608323, 47.018872],
      [10.606285, 47.017577],
      [10.60396, 47.01532],
      [10.600864, 47.01349],
      [10.599505, 47.013386],
      [10.598442, 47.012265],
      [10.598045, 47.010569],
      [10.597323, 47.009729],
      [10.595702, 47.008504],
      [10.593752, 47.007634],
      [10.593149, 47.006655],
      [10.590822, 47.00494],
      [10.589915, 47.003271],
      [10.587628, 47.001759],
      [10.58693, 47.000473],
      [10.585908, 46.999529],
      [10.582342, 46.998097],
      [10.58091, 46.996675],
      [10.579052, 46.995841],
      [10.575145, 46.99315],
      [10.57531, 46.992724],
      [10.576855, 46.992229],
      [10.575401, 46.990219],
      [10.575008, 46.988605],
      [10.568264, 46.982102],
      [10.567171, 46.981427],
      [10.564905, 46.981118],
      [10.5633, 46.980571],
      [10.559912, 46.978356],
      [10.556807, 46.976897],
      [10.551298, 46.973035],
      [10.545918, 46.970922],
      [10.544135, 46.968967],
      [10.544004, 46.968107],
      [10.543341, 46.968075],
      [10.542753, 46.967398],
      [10.540154, 46.966168],
      [10.538856, 46.964653],
      [10.536179, 46.963901],
      [10.534823, 46.962811],
      [10.530709, 46.961481],
      [10.528968, 46.960548],
      [10.527897, 46.959515],
      [10.525416, 46.958943],
      [10.524636, 46.957394],
      [10.521495, 46.956608],
      [10.519174, 46.955573],
      [10.517616, 46.955445],
      [10.516279, 46.954966],
      [10.515144, 46.954223],
      [10.514465, 46.953224],
      [10.509576, 46.949609],
      [10.511136, 46.94972],
      [10.509885, 46.949231],
      [10.508813, 46.948326],
      [10.507713, 46.944257],
      [10.500826, 46.94101],
      [10.496374, 46.937727],
      [10.494464, 46.937198],
      [10.492563, 46.93542],
      [10.49262, 46.934],
      [10.492171, 46.933202],
      [10.491184, 46.93249],
      [10.488169, 46.931697],
      [10.488419, 46.930642],
      [10.490512, 46.92997],
      [10.492896, 46.929805],
      [10.493592, 46.929101],
      [10.490759, 46.924632],
      [10.490224, 46.923049],
      [10.490796, 46.921087],
      [10.489702, 46.918266],
      [10.490483, 46.915532],
      [10.492408, 46.914435],
      [10.494775, 46.912262],
      [10.496211, 46.908613],
      [10.495886, 46.907392],
      [10.4924, 46.902171],
      [10.492912, 46.900708],
      [10.49426, 46.899013],
      [10.493708, 46.89694],
      [10.494065, 46.896825],
      [10.495279, 46.898504],
      [10.495066, 46.900738],
      [10.49559, 46.901524],
      [10.495612, 46.900232],
      [10.497922, 46.898344],
      [10.4989, 46.896754],
      [10.498605, 46.894567],
      [10.499855, 46.89273],
      [10.500073, 46.891562],
      [10.501184, 46.890822],
      [10.501602, 46.89164],
      [10.503103, 46.890454],
      [10.504818, 46.889794],
      [10.505979, 46.888528],
      [10.505903, 46.888032],
      [10.504375, 46.8869],
      [10.507829, 46.880771],
      [10.508883, 46.876654],
      [10.509951, 46.874561],
      [10.510135, 46.872131],
      [10.512146, 46.868484],
      [10.512534, 46.866984],
      [10.512254, 46.865112],
      [10.512621, 46.863631],
      [10.511648, 46.862848],
      [10.511444, 46.861276],
      [10.51059, 46.860839],
      [10.510024, 46.859979],
      [10.509097, 46.857463],
      [10.508616, 46.853143],
      [10.507308, 46.851444],
      [10.506888, 46.849831],
      [10.505739, 46.849126],
      [10.505738, 46.848104],
    ],
  },
];

// Rechecked against the production engine on 2026-08-26. The four independently
// rounded stage distances and the displayed trip total both resolve to 242.5 km.
export const demoTripDistanceKm = 242.5;
